import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-3 tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] md:tw-p-10" }
const _hoisted_2 = { class: "tw-bg-[#387DFF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded tw-mr-[10px]" }
const _hoisted_3 = { class: "tw-text-white tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_4 = { class: "tw-bg-[#F2F8FF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded" }
const _hoisted_5 = { class: "tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_6 = { class: "tw-mt-[12px]" }
const _hoisted_7 = { class: "tw-mr-[15px] tw-font-semibold tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_8 = { class: "tw-font-normal tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_9 = { class: "body-container" }

import { ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import {
  AssessmentAnswerType,
  IAssessmentQuestion,
} from "@/interfaces/assessments/IAssessmentQuestion";
import { PropType } from "vue";
import SwitchTabs from "../assessments/switchTabs.vue";
import OverrideAssessmentQuestion from "./overrideAssessmentQuestion.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalAssessment',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  titleClass: {
    type: String,
    default: "",
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;


const tabValue = ref(
  props.value.compensatingOverrideScore
    ? AssessmentAnswerType.COMPENSATING
    : AssessmentAnswerType.COMPLIANCE,
);
const tabs: ISwitchTabs[] = [
  { title: "Compliance override", id: AssessmentAnswerType.COMPLIANCE },
  { title: "Compensating controls", id: AssessmentAnswerType.COMPENSATING },
];

let showRef = ref(props.show);
let notInfoVisible = ref(true);
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[680px]",
    visible: _unref(showRef),
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header tw-capitalize ${__props.titleClass}`),
        title: props.value.title,
        onClose: handleCloseModal
      }, null, 8, ["class", "title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.value.category), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(props.value.subCategory), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.value.questionNumber), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(props.value.questionTitle), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(SwitchTabs, {
          tabs: tabs,
          "default-tab": __props.value.compensatingOverrideScore ? 1 : 0,
          "onUpdate:tab": _cache[0] || (_cache[0] = ($event: any) => (tabValue.value = $event))
        }, null, 8, ["default-tab"]),
        _createVNode(OverrideAssessmentQuestion, {
          type: tabValue.value,
          value: props.value
        }, null, 8, ["type", "value"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})